import React from "react";
import "./main.css";

// IMAGES
import Aboutme from "../aboutme/Aboutme";

function Main() {
  return (
    <div className="main">
      <div className="main-content-wrapper max-content-width flex">
        <div className="information_wrapper">
          <Aboutme />
        </div>
      </div>
    </div>
  );
}

export default Main;
